export const AU_STATES = ["NSW", "VIC", "QLD", "SA", "WA", "TAS", "NT", "ACT"];

export const VEHICLE_TYPES = ["BIKE", "CAR", "VAN", "UTE", "SUV", "TRUCK"];

export const VEHICLE_TYPE_LABELS = {
  BIKE: "Bike", CAR: "Car", VAN: "Van", UTE: "Ute", SUV: "SUV", TRUCK: "Truck",
};

export const RENT_MODES = ["FIXED_TERM", "PAYG"];
export const RENT_MODE_LABELS = {
  FIXED_TERM: "Fixed Term",
  PAYG: "Pay As You Go",
};

export const TIME_PERIODS = ["DAILY", "WEEKLY"];
export const TIME_PERIOD_LABELS = {
  DAILY: "Daily",
  WEEKLY: "Weekly",
};

export const FUEL_TYPES = ["PETROL", "DIESEL", "ELECTRIC", "HYBRID", "LPG"];

export const VEHICLE_STATUSES = ["AVAILABLE", "ON_HIRE", "MAINTENANCE", "RETIRED"];

export const VEHICLE_STATUS_LABELS = {
  AVAILABLE: "Available", ON_HIRE: "On Hire", MAINTENANCE: "Maintenance", RETIRED: "Retired",
};

export const RENTAL_STATUSES = [
  "DRAFT", "PENDING_SIGNATURE", "READY_FOR_PICKUP", "ON_HIRE",
  "RETURNED", "DAMAGE_REVIEW", "CLOSED", "CANCELLED",
];

export const RENTAL_STATUS_LABELS = {
  DRAFT: "Draft",
  PENDING_SIGNATURE: "Pending Signature",
  READY_FOR_PICKUP: "Ready for Pickup",
  ON_HIRE: "On Hire",
  RETURNED: "Returned",
  DAMAGE_REVIEW: "Damage Review",
  CLOSED: "Closed",
  CANCELLED: "Cancelled",
};

export const RENTAL_STATUS_COLORS = {
  DRAFT: { bg: "#F1F5F9", text: "#64748B", border: "#E2E8F0" },
  PENDING_SIGNATURE: { bg: "#FEF3C7", text: "#B45309", border: "#FDE68A" },
  READY_FOR_PICKUP: { bg: "#D1FAE5", text: "#047857", border: "#A7F3D0" },
  ON_HIRE: { bg: "#DBEAFE", text: "#1D4ED8", border: "#BFDBFE" },
  RETURNED: { bg: "#EDE9FE", text: "#6D28D9", border: "#C4B5FD" },
  DAMAGE_REVIEW: { bg: "#FFE4E6", text: "#E11D48", border: "#FECDD3" },
  CLOSED: { bg: "#CCFBF1", text: "#0D9488", border: "#99F6E4" },
  CANCELLED: { bg: "#F1F5F9", text: "#94A3B8", border: "#E2E8F0" },
};

export const FUEL_LEVELS = ["EMPTY", "1/4", "1/2", "3/4", "FULL"];

export const ACCESSORIES_LIST = [
  "Spare Tyre", "Jack", "First Aid Kit", "Fire Extinguisher",
  "Triangle", "Jumper Cables", "Torch", "Phone Charger",
];

export const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  const d = new Date(dateStr);
  return d.toLocaleDateString("en-AU", { day: "2-digit", month: "short", year: "numeric" });
};

export const formatDateTime = (dateStr) => {
  if (!dateStr) return "-";
  const d = new Date(dateStr);
  return d.toLocaleDateString("en-AU", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

export const isOverdue = (returnDatetime) => {
  if (!returnDatetime) return false;
  return new Date(returnDatetime) < new Date();
};

// Billing
export const BILLING_CYCLES = ["WEEKLY", "FORTNIGHTLY"];
export const BILLING_CYCLE_LABELS = { WEEKLY: "Weekly (7 days)", FORTNIGHTLY: "Fortnightly (14 days)" };
export const BILLING_CYCLE_DAYS = { WEEKLY: 7, FORTNIGHTLY: 14 };

// Invoice
export const INVOICE_STATUSES = ["DRAFT", "SENT", "PAID", "OVERDUE", "CANCELLED"];
export const INVOICE_STATUS_LABELS = {
  DRAFT: "Draft", SENT: "Sent", PAID: "Paid", OVERDUE: "Overdue", CANCELLED: "Cancelled",
};
export const INVOICE_STATUS_COLORS = {
  DRAFT: "#94a3b8", SENT: "#111111", PAID: "#16a34a", OVERDUE: "#dc2626", CANCELLED: "#6b7280",
};
